
import Package from './type/routes'
import Group from './group/routes'
import Module from './module/routes'

/* eslint-disable global-require */
const Packages = r => require.ensure([], () => r(require('./Main')), 'packages-bundle')

export default [
  {
    path: '/packages',
    component: Packages,
    meta: { requiresAuth: true },
    children: [...Package, ...Group, ...Module]
  }
]



// WEBPACK FOOTER //
// ./src/app/packages/routes.js